import axios from "axios";
import Vue from 'vue'
import store from '../index.js.erb'

const AdminPanelStmHostelStore = {
    namespaced: true,
    state: {
        all_count_statements: {},
        list_statements_on_faculty: [],
        list_statements_on_hostel: [],
        status_sync_stm_hostels: false,
        status_sync_hostel_orders: false,
        resp_message: ''
    },
    getters: {
    },
    mutations: {
        setAllCountStatements(state, all_count_statements){
            state.all_count_statements = all_count_statements
        },
        setListStatementsOnFaculty(state, list_statements_on_faculty){
            state.list_statements_on_faculty = list_statements_on_faculty
        },
        setListStatementsOnHostel(state, list_statements_on_hostel){
            state.list_statements_on_hostel = list_statements_on_hostel
        },
        setRespMessageSyncStmHostels(state, resp_message){
            state.resp_message = resp_message
        },
        setRespMessageSyncHostelOrders(state, resp_message){
            state.resp_message = resp_message
        }
    },
    actions: {
        async GetAllCountStatements({state, commit, dispatch}){
            await axios({
                method: 'get',
                url: '/statement_hostel/admin_panel/get_all_count_statements',
            }).then((response => {
                commit('setAllCountStatements', response.data)
            })).catch((error) => {
                return error
            })
        },
        async GetListStatementsOnFaculty({state, commit, dispatch}){
            await axios({
                method: 'get',
                url: '/statement_hostel/admin_panel/get_list_statements_on_faculty',
            }).then((response => {
                commit('setListStatementsOnFaculty', response.data)
            })).catch((error) => {
                return error
            })
        },
        async GetListStatementsOnHostel({state, commit, dispatch}){
            await axios({
                method: 'get',
                url: '/statement_hostel/admin_panel/get_list_statements_on_hostel',
            }).then((response => {
                commit('setListStatementsOnHostel', response.data)
            })).catch((error) => {
                return error
            })
        },
        async GetSyncStatementHostels({state, commit, dispatch}){
            state.status_sync_stm_hostels = true
            await axios({
                method: 'get',
                url: '/statement_hostel/statistics/admin_panel/sync_person_statement_hostel',
            }).then((response => {
                state.status_sync_stm_hostels = false
                commit('setRespMessageSyncStmHostels', response)
            })).catch((error) => {
                return error
            })
        },
        async GetSyncHostelOrders({state, commit, dispatch}){
            state.status_sync_hostel_orders = true
            await axios({
                method: 'get',
                url: '/statement_hostel/statistics/admin_panel/sync_hostel_orders',
            }).then((response => {
                state.status_sync_hostel_orders = false
                commit('setRespMessageSyncHostelOrders', response)
            })).catch((error) => {
                return error
            })
        },
    }
}

export default AdminPanelStmHostelStore